var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vPlotly',_vm._b({attrs:{"data":_vm.data,"layout":_vm.chart.layout,"id":_vm.chartId}},'vPlotly',_vm.chart.options,false))
}
var staticRenderFns = []

export { render, staticRenderFns }